export default __webpack_public_path__ + "static/media/ip.f2f30629.png";